<template>
  <div>
	<div class="separator seperator--mobile">
		<div class="page-wrapper">
			<div class="l-grid">
				<div class="l-grid__col-100 l-grid__col-lg-50">
					<h1 class="title u-weight-bolder" v-html="$t('careers.mainTitle')"></h1>
					<p class="text l-mt-40">{{ $t('careers.introText1') }}</p>
					<p class="text l-mt-20">{{ $t('careers.introText2') }}</p>
					<a href="#jobs" class="button l-mt-40">{{ $t('careers.viewOpenJobs') }}</a>

				</div>
				<div class="l-grid__col-100 l-grid__col-lg-50 l-grid l-grid--column l-grid--center">
					<img class="image-workers" src="@/assets/pages/careers/workers.png" alt=""/>
				</div>
			</div>

			<div class="l-grid l-mt-20 l-mt-lg-80 reverse-order-web">
				<div class="l-grid__col-100 l-grid__col-lg-50">
					<h1 class="title u-weight-bolder" v-html="$t('careers.descriptionTitle')"></h1>
					<p class="text u-weight-bolder">{{ $t('careers.descriptionSubtitle') }}</p>
					<p class="text l-mt-10">{{ $t('careers.descriptionText') }}</p>
					<ul class="l-grid l-grid--column l-mt-20">
						<li class="text l-grid l-grid--nowrap l-mb-20">
							<img src="@/assets/pages/careers/ico-work.svg" alt="" style="width: 50px;" class="l-mr-20"/><div><span class="u-weight-bolder u-underline">{{ $t('careers.perkTitle1') }}</span> - {{ $t('careers.perkDescription1') }}</div>
						</li>
						<li class="text l-grid l-grid--nowrap l-mb-20">
							<img src="@/assets/pages/careers/ico-rrsp.svg" alt="" style="width: 50px;" class="l-mr-20"/><div><span class="u-weight-bolder u-underline ">{{ $t('careers.perkTitle2') }}</span> - {{ $t('careers.perkDescription2') }}</div>
						</li>
						<li class="text l-grid l-grid--nowrap l-mb-20">
							<img src="@/assets/pages/careers/ico-benefit.svg" alt="" style="width: 50px" class="l-mr-20"/><div><span class="u-weight-bolder u-underline">{{ $t('careers.perkTitle3') }}</span> - {{ $t('careers.perkDescription3') }}</div>
						</li>
						<li class="text l-grid l-grid--nowrap l-mb-20">
							<img src="@/assets/pages/careers/ico-learn.svg" alt="" style="width: 50px" class="l-mr-20"/><div><span class="u-weight-bolder u-underline">{{ $t('careers.perkTitle4') }}</span> -  {{ $t('careers.perkDescription4') }}</div>
						</li>
					</ul>
				</div>
				<div class="l-grid__col-100 l-grid__col-lg-50 l-grid l-grid--column l-grid--center">
					<img class="image-office" src="@/assets/pages/careers/office.png" alt=""/>
				</div>
			</div>

			<dl id="jobs" class="jobs l-mt-20 l-mt-lg-80">
				<dt class="jobs__title">{{ $t('careers.listTitle') }}</dt>
				<dd class="jobs__item" v-for="job in $t('jobs')"><a :href="job.positionLink" class="jobs__link" target="_blank">{{ job.positionTitle }}</a></dd>
			</dl>

			<div class="form__wrap l-mt-20 l-mt-lg-50">
				<h1 class="form__title">{{ $t('careers.contactUs') }}</h1>
				<div :class="{ 'contact-form__success--visible': formSent }" class="contact-form__success">{{ $t('support.success') }}</div>
				<form @submit.prevent="submitForm">
					<label class="form__label form__label--light form__label--spaced">{{ $t('support.formName') }}</label>
					<input v-model="name" type="text" class="form__input form__input--spaced" autocomplete="name" required/>

					<label class="form__label form__label--light form__label--spaced">{{ $t('support.formEmail') }}</label>
					<input v-model="email" type="email" class="form__input form__input--spaced" autocomplete="email" required/>

					<label class="form__label form__label--light form__label--spaced">{{ $t('careers.formMessage') }}</label>
					<textarea v-model="message" class="form__textarea form__textarea--spaced" required></textarea>

					<div id="g-recaptcha" class="g-recaptcha" data-sitekey="6Ld-FbYpAAAAAIWvGa2WQrAILIyRzg8IIcJmW9Ba"></div>
					<div class="formcontrols">
						<input type="submit" class="l-mt-15 button button--light button--squared button--bold" :value="$t('careers.formSubmit')"/>
					</div>
				</form>
			</div>
		</div>
	</div>
  </div>
</template>


<script>


export default {
	components: {  },

	mounted () {
		grecaptcha.render('g-recaptcha');
	},

	i18n: { 
		messages: {
			'en-CA': {
				jobs: [
					{
						"positionLink": "https://docs.prospects.com/jobs/web-en.pdf",
						"positionTitle": "Web Developer - Java",
					},
					{
						"positionLink": "https://docs.prospects.com/jobs/SAC-en.pdf",
						"positionTitle": "Spécialiste, service à la clientèle (support technique)",
					},
					{
						"positionLink": "https://docs.prospects.com/jobs/sales-en.pdf",
						"positionTitle": "Sales Representative",
					},
					{
						"positionLink": "https://docs.prospects.com/jobs/admin-en.pdf",
						"positionTitle": "Accounting Clerk",
					},					
				]
			 },
			'fr-CA': { 
				jobs: [
					{
						"positionLink": "https://docs.prospects.com/jobs/web-fr.pdf",
						"positionTitle": "Développeur Web - Java",
					},
					// {
					// 	"positionLink": "https://docs.prospects.com/jobs/ios-fr.pdf",
					// 	"positionTitle": "Développeur iOS",
					// },
					// {
					// 	"positionLink": "https://docs.prospects.com/jobs/android-fr.pdf",
					// 	"positionTitle": "Développeur Android",
					// },
					{
						"positionLink": "https://docs.prospects.com/jobs/SAC-fr.pdf",
						"positionTitle": "Spécialiste, service à la clientèle (support technique)",
					},
					{
						"positionLink": "https://docs.prospects.com/jobs/sales-fr.pdf",
						"positionTitle": "Représentant des ventes",
					},	
					// {
					// 	"positionLink": "https://docs.prospects.com/jobs/admin-fr.pdf",
					// 	"positionTitle": "Commis comptable",
					// },
				]
			 }
		}
  	},

	data () {
		return {
			name: null,
			email: null,
			message: null,
			file: null,
			formSent: false
		}
	},

	computed: {

	},

	methods: {
		submitForm() {

			if(this.file === null || (this.file && this.file[0].size <= 10240)) {

				this.formSent = false;

				var formData = new FormData();
				formData.append("name", this.name);
				formData.append("email", this.email);
				formData.append("message", this.message);
				if(this.file) { formData.append("file", this.file); }
				formData.append("careers", true);
				formData.append("recapcha", document.querySelector('textarea[name="g-recaptcha-response"]').value);

				var xhr = new XMLHttpRequest();
				xhr.open("POST", "/mailer/mailer.php");
				xhr.send(formData);

				xhr.onreadystatechange = () => {
					if (xhr.readyState === 4 && xhr.status == 201) {
						this.name = "";
						this.email = "";
						this.message = "";
						this.file = "";
						this.formSent = true;
					}
				};
			}
			else {
				alert("Attachements must be under 10mb.")
			}

		}
	}
};
</script>

<style lang="scss" scoped>

	.image-workers { max-width: 100%; max-height: 550px; margin-top: 20px; }
	.image-office { max-width: 100%; max-height: 600px; margin-top: 20px; }

	.jobs { list-style:none; padding: 40px 30px; background: rgb(242,242,242); border-radius: 5px; }
	.jobs__title {
		color: #c51b1e;
		font-size: 2.5rem;
		font-weight: 700;
		border-bottom: 1px solid #343434;
		padding: 0 0 30px;
	}
	.jobs__item {
		border-bottom: 1px solid rgb(216,216,216);
		margin-left: 0;
	}
	.jobs__link {
		display: block;
		padding: 25px 60px 25px 0;
		font-weight: 700;
		position: relative;
		transition: background-color .4s ease-in-out;
		&:after {
			content: url('./../../assets/chevron.svg');
			height: 30px;
			width: 30px;
			right: 0;
			position: absolute;
		}
		&:hover {
			background-color: #e3e3e3;
		}
	}

	.form__wrap {
		padding: 40px 30px;
		border-radius: 5px;
		background: linear-gradient(45deg, rgba(225,0,0,1) 0%,rgba(154,0,0,1) 100%);
	}

	.form__title { font-size: 2.5rem; color: white; font-weight: 700; border-bottom: 1px solid white; padding: 0 0 30px; margin-bottom: 30px; }

	.form__label--light { color: #fff;}
	.form__label--spaced {margin-bottom: 10px;}
	.form__input--spaced, .form__textarea--spaced { margin-bottom: 20px;}

	.upload__field {
		height: 0;
	  	overflow: hidden;
	  	width: 0;
	}
	.upload__label {
		color: #fff;
		cursor: pointer;
		display: inline-block;
		margin-bottom: 1rem;
		outline: none;
		position: relative;
		transition: all 0.3s;
		vertical-align: middle;
	}

	.text--textbloc {
		margin-bottom: 15px;
		line-height: 2.5rem;
		font-size: 1.5rem;
	}
	.text--centered {
		text-align: center;
	}
	.button--light { background: none; border: 3px solid #fff;}
	.button--squared { border-radius: 0;}
	.button--bold { font-weight: 600;}
	.button--botMargin { margin-bottom: 20px;}
	.subtitle--bottomGap { margin-bottom: 50px;}

	.contact-form__success {
		background: #fff;
		color: #000;
		border: none;
		margin-bottom: 20px;
		font-weight: 600;
		text-align: center;
		line-height: 24px;
	}
	.contact-form__success--visible { display: block; }

	@media (min-width: 992px) {
		.image-workers { margin-top: -30px; place-self: flex-end; }
		.image-office { margin-left: -25px; margin-top: 0; place-self: flex-start; }
		.reverse-order-web { flex-direction: row-reverse; }
		.jobs { padding: 40px 60px; }
		.form__wrap { padding: 40px 60px; }
	}
</style>
